var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCyber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6281_4512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7568 12C19.7568 7.716 16.2839 4.24316 12 4.24316C7.716 4.24316 4.24316 7.716 4.24316 12C4.24316 16.2839 7.716 19.7568 12 19.7568C16.2839 19.7568 19.7568 16.2839 19.7568 12Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.16002C9.87924 8.16002 8.16002 9.87924 8.16002 12C8.16002 14.1208 9.87924 15.84 12 15.84C14.1208 15.84 15.84 14.1208 15.84 12C15.84 9.87924 14.1208 8.16002 12 8.16002ZM0.326416 12C0.326416 5.55286 5.55286 0.326416 12 0.326416C18.4472 0.326416 23.6736 5.55286 23.6736 12C23.6736 18.4472 18.4472 23.6736 12 23.6736C5.55286 23.6736 0.326416 18.4472 0.326416 12Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4512 12C18.4512 8.43713 15.5629 5.54883 12 5.54883C8.43713 5.54883 5.54883 8.43713 5.54883 12C5.54883 15.5629 8.43713 18.4512 12 18.4512C15.5629 18.4512 18.4512 15.5629 18.4512 12Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.1599C9.87925 8.1599 8.16002 9.87913 8.16002 11.9999C8.16002 14.1207 9.87925 15.8399 12 15.8399C14.1208 15.8399 15.84 14.1207 15.84 11.9999C15.84 9.87913 14.1208 8.1599 12 8.1599ZM2.93762 11.9999C2.93762 6.99487 6.995 2.9375 12 2.9375C17.005 2.9375 21.0624 6.99487 21.0624 11.9999C21.0624 17.0049 17.005 21.0623 12 21.0623C6.995 21.0623 2.93762 17.0049 2.93762 11.9999Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1456 12.0001C17.1456 9.15826 14.8418 6.85449 12 6.85449C9.15813 6.85449 6.85437 9.15826 6.85437 12.0001C6.85437 14.8419 9.15813 17.1457 12 17.1457C14.8418 17.1457 17.1456 14.8419 17.1456 12.0001Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.16003C9.87926 8.16003 8.16003 9.87926 8.16003 12C8.16003 14.1208 9.87926 15.84 12 15.84C14.1208 15.84 15.84 14.1208 15.84 12C15.84 9.87926 14.1208 8.16003 12 8.16003ZM5.54883 12C5.54883 8.43713 8.43713 5.54883 12 5.54883C15.5629 5.54883 18.4512 8.43713 18.4512 12C18.4512 15.5629 15.5629 18.4512 12 18.4512C8.43713 18.4512 5.54883 15.5629 5.54883 12Z",
    fill: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.84 11.9999C15.84 9.87914 14.1208 8.15991 12 8.15991C9.87926 8.15991 8.16003 9.87914 8.16003 11.9999C8.16003 14.1207 9.87926 15.8399 12 15.8399C14.1208 15.8399 15.84 14.1207 15.84 11.9999Z",
    fill: "#EAEAEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6281_4512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyber);
export default __webpack_public_path__ + "static/media/cyber.0f894fc454be348edc82658168bf721a.svg";
export { ForwardRef as ReactComponent };